import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Businesses from "@/pages/Businesses";
import BusinessDetail from "@/pages/BusinessDetail";
import Cards from "@/pages/Cards";
import CardDetail from "@/pages/CardDetail";
import QRExport from "@/pages/QRExport";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/businesses" element={<Protected><Businesses /></Protected>} />
            <Route path="/businesses/:id" element={<Protected><BusinessDetail /></Protected>} />
            <Route path="/cards" element={<Protected><Cards /></Protected>} />
            <Route path="/cards/:cardCode" element={<Protected><CardDetail /></Protected>} />
            <Route path="/qr" element={<Protected><QRExport /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
